import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import { getLocalResetTime } from '../utils/timeUtils';
import './QuotaAlert.css';

/**
 * Unified Quota Alert Modal
 * Shown when the user reaches their daily or total image generation limit.
 */
const QuotaAlert = ({ isOpen, onClose }) => {
  const { t } = useI18n();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const resetTime = getLocalResetTime();

  return (
    <div className="quota-alert-overlay">
      <div className="quota-alert-content">
        <div className="quota-alert-icon">⚠️</div>
        <h2 className="quota-alert-title">{t('settings.imagePlans')}</h2>
        <p className="quota-alert-message">
          {t('common.quotaReachedAlert', { time: resetTime })}
        </p>
        <div className="quota-alert-actions">
          <button
            className="quota-alert-btn secondary"
            onClick={onClose}
          >
            {t('common.close')}
          </button>
          <button
            className="quota-alert-btn primary"
            onClick={() => {
              onClose();
              navigate('/ajustes');
            }}
          >
            {t('common.upgradePlan')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaAlert;
